<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...$$restProps}>
	<path d="M7.5 6H10.5V18H7.5V6Z" fill="currentColor" />
	<path d="M13.5 6H16.5V18H13.5V6Z" fill="currentColor" />
</svg>
